module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/098-guatemala-c5fa4fa024f746530716bfab8cbf73b6.svg";